exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ModelPortfolio__cardHolder {\n  margin: 0 25px; }\n\n.ModelPortfolio__donut_table_Holder__donut {\n  margin-top: 5px; }\n\n.ModelPortfolio .slick-next::before {\n  content: none; }\n\n.ModelPortfolio .slick-prev::before {\n  content: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/ModelPortfolio.style.scss
// module id = 1658
// module chunks = 0